/* eslint-disable camelcase */
export enum OrderServiceStage {
  // 2待处理 3待确认 4已完成
  SERVICE_STAGE = '', // all
  SERVICE_STAGE_UNDEAL = 2, // 待处理
  SERVICE_STAGE_UNCOMPLETED = 3, // 进行中
  SERVICE_STAGE_FINISH = 4, // 已完成
  SERVICE_STAGE_TRANSFER = 7, // 转单
  SERVICE_STAGE_SUB_NULL = '', // 所有订单
  SERVICE_STAGE_SUB_UNDERWAY = 2, // 进行中
  SERVICE_STAGE_SUB_APPEAR = 3, // 上报
  SERVICE_STAGE_SUB_HANDUP = 4, // 挂单
  SERVICE_STAGE_SUB_TRANSFER = 5, // 转出单
  SERVICE_STAGE_SUB_FINISH = 6, // 已完成
  SERVICE_STAGE_SUB_CLOSE = 7, // 已关闭
  SERVICE_STATUS_RECYCLE = -1, // 回收站 status = -1
  SERVICE_STATUS_GRAB = 15, // 抢单
  SERVICE_STATUS_TIMEOUT = 11, // 超时单

  SERVICE_STAGE_OUT_SOURCE = 8, // 委外进行中
}

export declare class IOrderServiceParams {
  user_id: number
  company_id: string
  page: number
  size?: number
  stage?: OrderServiceStage
  stage_sub?: OrderServiceStage
  is_need_task?: number
}

export enum ViewType {
  ORDER_SERVICER = 0, // 默认
  ORDER_SERVICER_ALL = 1, // 所有订单
  ORDER_SERVICER_COMPLETED = 2, // 完结单
  ORDER_SERVICER_COMPLETED_SETTLE = 23, // 结算订单
  ORDER_SERVICER_GRAB = 3, // 抢单列表
  ORDER_SERVICER_HANG = 4, // 挂单中
  ORDER_SERVICER_RECYCLE = 5, // 回收站
  ORDER_SERVICER_REPORT = 6, // 上报中
  ORDER_SERVICER_TRANSFER = 7, // 转单列表
  ORDER_SERVICER_UNDERWAY = 8, // 进行中
  ORDER_SERVICER_UNTREATED = 9, // 待处理
  ORDER_SERVICER_TIMEOUT = 10, // 超时单
  ORDER_SERVICER_CREATE_MY = 11, // 我添加的订单
  ORDER_SERVICER_CUSTOMER_ORDER = 12, // 客户订单
}
